// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"271":"bfad8eb62f327529","920":"a0f0d9ae540cef22"}[chunkId] + ".css";
};